import { CoreMeasure } from '@bepatient/core';

export interface ManualMeasureData {
  [key: string]: number | string;
  measureDatetime: string;
}

export interface ManualMeasureInfos {
  measure: CoreMeasure;
  measureData: ManualMeasureData;
  userId: number;
  appVersion: string;
  instanceCode: string;
}
